module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "omar-alshogre.e78db93b.jpg" + "?" + Date.now();